// extracted by mini-css-extract-plugin
export default {"footerMenu":"footerMenu_footerMenu__mTF0r","footerMenu__list":"footerMenu_footerMenu__list__EbvYH","footerMenu__title":"footerMenu_footerMenu__title__nH3Em"};